import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['menu'];

  toggle(event) {
    const menu = this.menuTarget;
    const expanded = menu.style.display !== 'block';
    menu.style.display = expanded ? 'block' : 'none';
    event.currentTarget.setAttribute('aria-expanded', String(expanded));
  }
}
